import { Link } from "react-router";
import { cn } from "@util/helpers";

type CardGroupedListItemProps = {
  /** The id of the article */
  id: string;
  /** The Article link to be redirected */
  link: string;
  /** The title of the article */
  title: string;
  /** Optional additional styling for the container */
  className?: string;
  /** The kicker of the article */
  kicker?: string;
};

/**
 * Renders a list of grouped article cards.
 * Figma: https://www.figma.com/design/rR8akVWS3SksIyaOSqetu4/BAU--WEB---APP-?node-id=15283-30089&t=e9A81BzeElIUYdlc-4
 */
const CardGroupedListItem = ({
  link,
  title,
  kicker,
  className,
}: CardGroupedListItemProps): React.ReactElement | null => {
  return (
    <div className={cn("relative text-gray-550", className)}>
      {kicker ? (
        <span className="pb-2 font-poppins text-5xs font-normal leading-130 tracking-10 text-white">
          {kicker}
        </span>
      ) : null}

      <Link
        to={link}
        className={cn(
          "block -tracking-2 text-white hover:underline",
          "before:absolute before:left-0 before:right-0 before:top-0 before:h-px before:bg-gray-750"
        )}
        data-testid="card-grouped-list-item-component"
        reloadDocument
      >
        {title}
      </Link>
    </div>
  );
};

export default CardGroupedListItem;
